import { apiCall } from "./Interceptor";

const CONSUMER_DETAILS = "/consumer-detail/get";
const CONSUMER_DETAILS_CREATE = "/consumer-detail/create";

const createConsumer = async (data) => {
 const response = await apiCall.post(CONSUMER_DETAILS_CREATE, data);
 return response;
};

const getConsumerDetails = async (id) => {
 let url = CONSUMER_DETAILS;

 if (id) {
  url += `?id=${id}`;
 }

 const response = await apiCall.get(url);
 return response;
};

export default {
 getConsumerDetails,
 createConsumer,
};
